import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';
import TableUser from '@/components/core/Table/CustomCells/TableUser';
import TablePositionCell from '@/components/core/Table/CustomCells/TablePositionCell';
import { getComputedColor } from '@starsoft/common/utils';
import { RollCompetitionEntries } from '@/models/roll-competition/entries';
import { RollCompetitionEntryWithPlaceAndPrize } from '@/models/roll-competition/entries/with-place/inde';
import RollCompetitionPrizeCell from '@/components/core/Table/CustomCells/RollCompetitionPrizeCell';
import { getCookie } from 'cookies-next';
import { CookiesKey } from '@starsoft/common/enums';

export const rollCompetitionLeaderboardColumns: TableGridColumn<RollCompetitionEntryWithPlaceAndPrize>[] =
  [
    {
      field: 'place',
      headerName: 'table_position',
      renderCell: row => <TablePositionCell hideLabel position={row?.place} />,
    },
    {
      field: 'player.username',
      headerName: 'table_username',
      renderCell: (row: RollCompetitionEntries) => (
        <TableUser player={row?.player} />
      ),
    },
    {
      field: 'rolled',
      headerName: 'table_score',
      renderCell: row => (
        <p
          style={{
            color: getComputedColor('--primary-color'),
            fontWeight: 700,
          }}
        >
          {row?.rolled}
        </p>
      ),
    },
    {
      field: 'prize',
      headerName: 'table_prize',
      renderCell: (row: RollCompetitionEntryWithPlaceAndPrize) => (
        <RollCompetitionPrizeCell prize={row?.prize} />
      ),
    },
    {
      field: 'createdAt',
      headerName: 'created',
      valueFormatter: row =>
        Intl.DateTimeFormat(getCookie(CookiesKey.Lang) as string, {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).format(new Date(row.createdAt ?? new Date())),
    },
  ];
